export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6c-a85e6ad6b176bdde6f116fd0dadd6f3d.webp";